// extracted by mini-css-extract-plugin
export default {"popup":"pricesPopup_popup__mkQHK"};